module.exports = __webpack_public_path__ + "img/collection-memoireRingsConfigurator@2x.33d12e0.jpg";